import React, { useState } from "react";
import Table from "../../stories/Table";
import { Link, navigate } from "@reach/router";
import { format } from "date-fns";
import { getErrorData, getURLParams, handleQuery } from "../../service/Helper";
import { useCaseTypeList } from "../../service/Fetchers";
import { DashboardView } from "../../stories/DashboardView";

const perPageCount = 10;
const ListCaseType = () => {
  const currentPage = getURLParams("page") ?? 1;
  const searchQ = getURLParams("search") ?? "";

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(currentPage);

  const { caseTypes, pageInfo, loading, error, isValidating, mutate } =
    useCaseTypeList({
      currentPage: page,
      perPageCount,
      searchQuery: searchQ,
    });

  const loadingData = loading || isValidating;

  const content = (
    <Table
      headers={["Case Type ID", "Name", "Date Added", "No Of Associated cases"]}
      pagination={{
        currentpage: pageInfo.current_page,
        itemsPerPage: pageInfo.per_page,
        totalItems: pageInfo.total_count,
        onPageChange: (page) => {
          handleQuery(navigate, page, searchQ, "case-types");
        },
      }}
      loading={loadingData}
      rowContent={caseTypes.map((caseType) => [
        <p className="underline text-primary">
          <Link to={`/dashboard/case-types/view/${caseType.id}`}>
            {caseType.id}
          </Link>
        </p>,
        <p>{caseType.name}</p>,
        <p>{format(new Date(), "dd-MMM-yyyy")}</p>,
        <p>{caseType.visit_count}</p>,
      ])}
    />
  );

  const headerData = {
    constructiveCTA: {
      link: "/dashboard/case-types/add",
      title: "Add Case Type",
    },
    states: [
      {
        title: "Case Type List",
      },
    ],
    title: "List of case types",
    search: {
      show: true,
      searching: searchQuery.length && loadingData,
      placeholder: "Search using Case Type Name...",
      onSearch: (values) => {
        setPage(1);
        handleQuery(navigate, 1, values.query, "case-types");
        setSearchQuery(values.query);
      },
      onChange: (values) => {
        if (!values.query) {
          setSearchQuery("");
        }
      },
    },
  };

  const errorData = getErrorData({
    error,
    searchQuery,
    data: caseTypes,
    mutate,
    title: "Case Types",
  });

  return (
    <DashboardView
      headerData={headerData}
      content={content}
      errorData={errorData}
      loading={loadingData}
      loadingContent={null}
    />
  );
};

export default ListCaseType;
